import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { apiGet, apiPost } from "../../utils/api";

const StudyGroupsAdmin = () => {
  const [elements, setElements] = useState([]);

  async function exibir() {
    const payload = apiGet("/study_group");
    setElements((await payload).data.data);
  }

  useEffect(() => {
    exibir();
  }, []);

  function deleteElement(id) {
    deleteById(id).then(
      (payload) => {
        alert("Elemento removido!", "success");

        setElements(elements.filter((item) => item.group_id !== id));
      },
      (error) => {
        let message = "Erro ao remover!";

        if (error.status === 401) {
          message = "Sem autorização.";
        }
        alert(message, "error");
      }
    );
  }

  async function deleteById(id) {
    const payload = apiPost("/study_group/delete/" + id);
    return await payload;
  }

  async function cadastrarElemento(value) {
    const payload = apiPost("/study_group/", { title: value });
    return await payload;
  }

  function cadastrar() {
    var value = document.getElementById("new_group_name").value;

    cadastrarElemento(value).then(
      (payload) => {
        alert("Elemento adicionado!", "success");
        document.getElementById("new_group_name").value = "";
        exibir();
      },
      (error) => {
        let message = "Erro ao adicionar!";

        if (error.status === 401) {
          message = "Sem autorização.";
        }
        alert(message, "error");
      }
    );
  }

  return (
    <>
      <section id="management" style={{ paddingTop: "100px" }}>
        <div className="row text-center justify-content-center">
          <h2 className="text-black mb-4">Gerenciar Grupos de Estudo</h2>
        </div>
      </section>

      <Link className="btn btn-secondary" to={"/management"}>
        Voltar
      </Link>

      <hr />

      <div>
        <h4>Cadastrar novo grupo:</h4>
        Nome: <input type="text" className="w-25 p-3" id="new_group_name" />
        <button onClick={() => cadastrar()} className="btn btn-primary">
          Salvar
        </button>
      </div>

      <hr />

      <h4>Grupos cadastrados:</h4>

      <>
        {elements && elements.length
          ? elements.map((item) => {
              return (
                <div key={item.group_id}>
                  {item.title}
                  &nbsp; &nbsp; &nbsp; &nbsp;
                  <button
                    onClick={() => deleteElement(item.group_id)}
                    className="btn btn-primary"
                  >
                    Remover
                  </button>
                </div>
              );
            })
          : null}
      </>
    </>
  );
};

export default StudyGroupsAdmin;
